'use strict';

import React, { PropTypes } from 'react';
import { Provider } from 'react-redux';
import { Router } from 'react-router';
import config from 'config';

class RootComponent extends React.Component {

	content () {
		return (
			<Router history={this.props.history}>
				{this.props.routes}
			</Router>
		)
	}

	// TODO: Return null in production.
	devTools () {
    if (config.appEnv === 'devx') {
      const DevTools = require('./devTools/devTools').default
      return <DevTools />
    }
	}

  render() {
    return (
    	<Provider store={this.props.store}>
    		<div style={{height: '100%' }}>
    			{this.content()}
    			{this.devTools()}
    		</div>
    	</Provider>
    );
  }
}

RootComponent.propTypes = {
  history: PropTypes.object.isRequired,
  routes: PropTypes.object.isRequired,
  store: PropTypes.object.isRequired
}

export default RootComponent;



// WEBPACK FOOTER //
// ./src/components/root.container.jsx